import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, Th, Td, Empty } from "./ui";

export default function Customers() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/customers").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader title="Klanten" subtitle="Zakelijke klanten op basis van bestellingen" />
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="border-b border-white/10"><tr><Th>Bedrijf</Th><Th>KvK</Th><Th>Contact</Th><Th>E-mail</Th><Th>Plaats</Th><Th>Orders</Th><Th>Besteed</Th></tr></thead>
            <tbody>
              {rows.map((c, i) => (
                <tr key={i} className="border-b border-white/5" data-testid={`customer-row-${c.kvk_number}`}>
                  <Td>{c.company_name}</Td><Td>{c.kvk_number}</Td><Td>{c.contact_person}</Td>
                  <Td className="text-white/60">{c.email}</Td><Td>{c.city}</Td>
                  <Td>{c.order_count}</Td><Td>€{c.total_spent.toFixed(2)}</Td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <Empty text="Nog geen klanten" />}
        </div>
      </Card>
    </div>
  );
}
